import * as hubspot from 'utils/analytics/hubspot';

export const hubspotTrackStepView = (step: string) => {
  if (typeof window === 'undefined') return;

  const { pathname } = window.location;
  hubspot.trackPageView({ path: `${pathname}?step=${step}` });
};
